var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9099 15.1115C18.8386 15.0255 18.7685 14.9396 18.6998 14.8567C17.7545 13.7133 17.1826 13.0232 17.1826 9.78635C17.1826 8.11057 16.7817 6.73557 15.9915 5.70432C15.4088 4.94248 14.6212 4.36455 13.5831 3.93744C13.5697 3.93001 13.5578 3.92026 13.5478 3.90865C13.1744 2.65826 12.1527 1.8208 11.0002 1.8208C9.84781 1.8208 8.82644 2.65826 8.45304 3.90736C8.44309 3.91856 8.43133 3.92801 8.41824 3.93529C5.99566 4.9326 4.81832 6.846 4.81832 9.78506C4.81832 13.0232 4.24726 13.7133 3.30109 14.8554C3.23234 14.9383 3.1623 15.0225 3.09097 15.1102C2.90672 15.3324 2.78998 15.6027 2.75458 15.8892C2.71917 16.1757 2.76657 16.4663 2.89117 16.7267C3.15628 17.2853 3.72132 17.632 4.36628 17.632H17.6389C18.2809 17.632 18.842 17.2857 19.108 16.7297C19.2331 16.4692 19.281 16.1784 19.2459 15.8916C19.2108 15.6048 19.0942 15.334 18.9099 15.1115ZM11.0002 21.0708C11.6211 21.0703 12.2303 20.9018 12.7632 20.583C13.2961 20.2643 13.7328 19.8073 14.0269 19.2605C14.0408 19.2343 14.0477 19.205 14.0468 19.1753C14.046 19.1457 14.0375 19.1168 14.0222 19.0914C14.0069 19.066 13.9853 19.045 13.9594 19.0305C13.9336 19.0159 13.9045 19.0083 13.8748 19.0083H8.12648C8.0968 19.0082 8.0676 19.0158 8.04172 19.0303C8.01584 19.0448 7.99416 19.0658 7.97881 19.0912C7.96345 19.1166 7.95492 19.1456 7.95407 19.1752C7.95322 19.2049 7.96006 19.2343 7.97394 19.2605C8.26808 19.8073 8.70469 20.2642 9.23748 20.5829C9.77028 20.9016 10.3794 21.0702 11.0002 21.0708Z",
    fill: "#032A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1162,
    cy: 4.8208,
    r: 2.6,
    fill: "#E37B00",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.bedb5dc5148dd9d925bf7b848790577e.svg";
export { ForwardRef as ReactComponent };